<template>
  <div class="toast" :class="{ show: toast.visible }" id="toast" role="status" aria-live="polite">{{ toast.message }}</div>
</template>

<script>
import { toastState } from '@/composables/useToast';

export default {
  name: 'SiteToast',
  data: () => ({ toast: toastState }),
};
</script>
